import {legalServices} from '../service-request/constants'

export const getRelatedServiceContent = (service: string) =>
  legalServices.find(({key}) => key === service)
